<template>
    <div id="datatable-names-backoffice">
        <v-data-table
            :headers="headers"
            :items="listNames"
            :hide-default-footer="true"
            dense
        >
            <template v-slot:[`item.name`]="{ item }">
                <v-text-field
                    v-if="item.edit"
                    v-model="item.name"
                    single-line
                ></v-text-field>
                <span v-else>{{ item.name }}</span>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                <div class="div-actions">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span
                                @click="onEditName(item)"
                                style="cursor: pointer"
                                v-bind="attrs"
                                v-on="on"
                                v-show="!item.edit"
                            >
                                <img
                                    src="/images/_SVGs/bo/edit_pencil.svg"
                                    :alt="$t('edit')"
                                    onload="SVGInject(this)"
                                    width="20"
                                    height="20"
                                />
                            </span>
                        </template>
                        <span>{{ $t("edit") }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span
                                @click="$emit('on-delete-name', item)"
                                style="cursor: pointer"
                                class="mr-2 p-0"
                                v-bind="attrs"
                                v-on="on"
                                v-show="!item.edit"
                            >
                                <img
                                    src="/images/_SVGs/bo/remove.svg"
                                    :alt="$t('delete')"
                                    onload="SVGInject(this)"
                                    width="30"
                                    height="30"
                                    class="circle"
                                />
                            </span>
                        </template>
                        <span>{{ $t("delete") }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span
                                @click="onConfirmName(item)"
                                class="mr-2 p-0"
                                :class="
                                    item.name ? 'fullOpacity' : 'halfOpacity'
                                "
                                v-bind="attrs"
                                v-on="on"
                                v-show="item.edit"
                                disabled
                            >
                                <img
                                    src="/images/_SVGs/bo/check-circle.svg"
                                    :alt="$t('confirm')"
                                    onload="SVGInject(this)"
                                    width="30"
                                    height="30"
                                    class="circle"
                                />
                            </span>
                        </template>
                        <span>{{ $t("confirm") }}</span>
                    </v-tooltip>
                </div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        listNames: Array | Object,
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t(
                        "backoffice.modules.promo-engine.description"
                    ),
                    align: "start",
                    value: "name",
                    width: "80%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: "",
                    align: "start",
                    value: "actions",
                    width: "20%",
                    class: "header-table-color",
                    sortable: false,
                },
            ],
        };
    },
    methods: {
        onConfirmName(item) {
            if (item.name) {
                this.$emit("on-name-changed", item);
            }
        },
        onEditName(item) {
            item.edit = true;
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-names-backoffice {
    tr {
        height: 42px;
    }
}

.fullOpacity {
    cursor: pointer;
}
.halfOpacity {
    opacity: 0.5;
    cursor: auto;
}
</style>
